import type React from 'react';
import { cn } from '../../../lib';

type BlockquoteProps = {
  className?: string;
  children: React.ReactNode;
};

function Blockquote({ className, children }: BlockquoteProps) {
  return (
    <div
      className={cn(
        'p-5 bg-orange-100 border-l-4 border-orange-400 text-sm text-slate-800',
        className,
      )}
    >
      {children}
    </div>
  );
}

export { Blockquote };
